import {useTranslations} from 'next-intl';
import {spaceNumber} from '@/libs/number.util';

export default function PriceRangeInput({ currency, priceFromInput, priceToInput, priceRanges, onPriceRemove, onPriceChange }) {
  const t = useTranslations('catalog');
  return (
      <>
        <div className="price-input-from">
          <input
              type="text"
              placeholder={t('priceFrom')}
              defaultValue={priceFromInput?.value != null ? `${t('from')} ${currency?.left ? currency?.symbol : ''}${spaceNumber(priceFromInput?.value)}${!currency.left ? currency?.symbol : ''}` : null}
              readOnly
          />
          <ul>
            {
              Number.isInteger(priceFromInput?.value) ? (
                  <li
                      className="linkable"
                      onClick={() => onPriceRemove('from')}
                  >
                    <span>{t('remove')}</span>
                  </li>
              ) : ''
            }
            {
              priceRanges.map((item, idx) => (
                  <li
                      key={idx}
                      className={`linkable ${item.value === priceFromInput?.value ? 'link-active bold' : ''} ${item.value > priceToInput?.value ? 'link-disable' : ''}`}
                      onClick={() => onPriceChange(item, 'from', priceToInput?.value)}
                  >
                    <span>
                      {currency?.left ? (<span className="currency-sign-font">{currency?.symbol}</span>) : ''}
                      {item.title}
                      {!currency.left ? (<span className="currency-sign-font">{currency?.symbol}</span>) : ''}
                    </span>
                  </li>
              ))
            }
          </ul>
        </div>
        <span className="price-dash">{' - '}</span>
        <div className="price-input-to">
          <input
              type="text"
              placeholder={t('priceTo')}
              defaultValue={priceToInput?.value ? `${t('to')} ${currency?.left ? currency?.symbol : ''}${spaceNumber(priceToInput?.value)}${!currency.left ? currency?.symbol : ''}` : null}
              readOnly
          />
          <ul>
            {
              Number.isInteger(priceToInput?.value) ? (
                  <li
                      className="linkable"
                      onClick={() => onPriceRemove('to')}
                  >
                    <span>{t('remove')}</span>
                  </li>
              ) : ''
            }
            {
              priceRanges.map((item, idx) => (
                  <li
                      key={idx}
                      onClick={() => onPriceChange(item, 'to', priceFromInput?.value)}
                      className={`linkable ${item.value === priceToInput?.value ? 'link-active bold' : ''} ${item.value < priceFromInput?.value ? 'link-disable' : ''}`}
                  >
                    <span>
                      {currency?.left ? (<span className="currency-sign-font">{currency?.symbol}</span>) : ''}
                      {item.title}
                      {!currency.left ? (<span className="currency-sign-font">{currency?.symbol}</span>) : ''}
                    </span>
                  </li>
              ))
            }
          </ul>
        </div>
      </>
  );
};
